import { Injectable } from '@angular/core';
import { IControlModel } from '../models/models';

/**
 * holds the current control to share between main controls route and subroutes
 * this should only be used in 'dumb' routing components and passed down to the actual components
 */

@Injectable({
    providedIn: 'root'
})
export class CurrentControlService {
    private _currentControl: IControlModel;

    public setCurrentControl(control: IControlModel) {
        this._currentControl = control;
    }

    public get currentControl() {
        return this._currentControl;
    }
}
